import Modal from 'react-modal'
import { FormattedMessage } from 'react-intl'

import './confirmation-popup.sass'

const ConfirmationPopup = ({ isOpen, onConfirm, onReject }) => {
  return (
    <Modal
      isOpen={isOpen}
      ariaHideApp={false}
      className='Modal react-popup form-popup confirmation-popup'
      overlayClassName='Overlay'
      contentLabel='Confirmation popup'
    >
      <div className='confirmation-popup__wraper'>
        <div className='confirmation-popup__title'>
          <h3>
            <FormattedMessage
              id='popup.confirmation'
              defaultMessage='Are you sure?'
            />
          </h3>
        </div>
        <div className='confirmation-popup__body'>
          <button className='btn-red' onClick={onConfirm}>
            <FormattedMessage id='yes' defaultMessage='Yes' />
          </button>
          <button className='btn-red-invert' onClick={onReject}>
            <FormattedMessage id='no' defaultMessage='No' />
          </button>
        </div>
      </div>
    </Modal>
  )
}

export default ConfirmationPopup
